import { render, staticRenderFns } from "./new-sku-modal.vue?vue&type=template&id=2fd5ade0"
import script from "./new-sku-modal.vue?vue&type=script&lang=js"
export * from "./new-sku-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports